export default "__VITE_ASSET__$wkQj6pA__"